import React from "react";
import { Modal } from "react-bootstrap";
import { updateCurrentUserRedux } from "../../../../api/helper";

export default ({ show, hide }) => {
  const handleClose = () => {
    updateCurrentUserRedux();
    hide();
  };

  return (
    <Modal
      className="unsubscribe-primo-modal"
      show={show}
      onHide={handleClose}
      animation={true}
    >
      <Modal.Body className="text-center p-4 m-3">
        <p className="text-uppercase">Done! We're sad to see you go,</p>
        <p className="text-uppercase">but you can always</p>
        <p className="text-uppercase">resubscribe anytime</p>

        <div className="d-flex justify-content-center">
          <button
            variant="primary"
            className="btn btn-md btn-primary text-uppercase mt-3"
            onClick={handleClose}
          >
            GOTCHA
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
